import React from 'react';
import Widget from '../Widget';
import WidgetTitle from '../WidgetTitle';
import NoData from '../NoData';
import HorizontalStackedBar from '../../Charts/HorizontalStackedBar';
import TableToggle from '../TableToggle';
import { Col, Row } from 'react-bootstrap';
import KeyValueData from '../../Charts/KeyValueData';
import useTableToggle from '../../Hooks/useTableToggle';

export default function OutcomesEightYearsAfterAttending({ institutionData }) {

    const title = 'Outcomes Eight Years After Attending';
    const { table, handleTable } = useTableToggle();
    const outcomes = institutionData.scorecard.outcomes;

    if (!institutionData.scorecard.id) {
        return <NoData widgetTitle={title} />;
    }

    const data = {
        graduated: outcomes.data['8yr'].award_pooled,
        transferred: outcomes.data['8yr'].transfer_pooled,
        withdrew: outcomes.data['8yr'].unknown_pooled,
        still_enrolled: outcomes.data['8yr'].still_enrolled_pooled
    }

    let total = outcomes.cohort.full_time.first_time["8yr_pooled"];
    total += outcomes.cohort.full_time.not_first_time["8yr_pooled"];
    total += outcomes.cohort.part_time.first_time["8yr_pooled"];
    total += outcomes.cohort.part_time.not_first_time["8yr_pooled"];

    return (
        <Widget className="container outcomes-eight-years-after-attending">
            <Row gap={5} gap-lg={0}>
                <Col xs={12} sm={9}>
                    <WidgetTitle>{title}</WidgetTitle>
                </Col>
                <Col xs={12} sm={3}>
                    <TableToggle handleTable={handleTable} table={table} />
                </Col>
            </Row>
            {!table ?
                <div>
                    <p><strong>Out of {total.toLocaleString()} students...</strong></p>
                    <HorizontalStackedBar data={data} />
                </div>
                : <KeyValueData data={[
                    { label: 'Graduated', value: data.graduated },
                    { label: 'Transferred', value: data.transferred },
                    { label: 'Withdrew', value: data.withdrew },
                    { label: 'Still Enrolled', value: data.still_enrolled }
                ]}>
                    <p><strong>Out of {total.toLocaleString()} students...</strong></p>
                </KeyValueData>}
        </Widget>
    );
}